<script setup>
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import MultiselectDropdown from 'shared/components/ui/MultiselectDropdown.vue';
import { DELAY_UNITS } from '../../../constants/nodeTypes.js';

const { t } = useI18n();

const props = defineProps({
  modelValue: { type: Object, default: () => ({}) },
});
const emit = defineEmits(['update:modelValue']);

const UNIT_OPTIONS = computed(() => DELAY_UNITS.map(u => ({ id: u.key, name: t(u.label) })));

function parse(mins) {
  const m = mins ?? 1;
  if (m % 1440 === 0 && m > 0) return { amount: m / 1440, unit: 'days' };
  if (m % 60 === 0 && m > 0)   return { amount: m / 60,   unit: 'hours' };
  return { amount: m || 1, unit: 'minutes' };
}

const init = parse(props.modelValue?.delay_minutes);
const amount = ref(init.amount);
const unit   = ref(init.unit);

watch(() => props.modelValue?.delay_minutes, mins => {
  const p = parse(mins);
  amount.value = p.amount;
  unit.value   = p.unit;
});

function emitUpdate() {
  const u = DELAY_UNITS.find(d => d.key === unit.value);
  emit('update:modelValue', { ...props.modelValue, delay_minutes: amount.value * (u?.multiplier ?? 1) });
}

const selectedUnit = computed(() => UNIT_OPTIONS.value.find(o => o.id === unit.value) ?? null);

function onSelectUnit(val) {
  unit.value = val?.id ?? 'minutes';
  emitUpdate();
}
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <label class="text-xs font-medium text-n-slate-11">{{ t('FLOW_BUILDER.ACTION_FORMS.DELAY_NODE.WAIT') }}</label>
    <div class="flex gap-2 items-center">
      <input
        v-model.number="amount"
        type="number"
        min="1"
        class="w-24 h-9 rounded-lg border border-n-weak bg-n-solid-1 px-3 text-sm text-n-slate-12 focus:outline-none focus:ring-1 focus:ring-n-brand"
        @change="emitUpdate"
      />
      <div class="multiselect-wrap--small flex-1">
        <MultiselectDropdown
          :options="UNIT_OPTIONS"
          :selected-item="selectedUnit"
          :has-thumbnail="false"
          :hide-search="true"
          @select="onSelectUnit"
        />
      </div>
    </div>
  </div>
</template>
